var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGooglePhotosLogo = function SvgIconGooglePhotosLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.375 1.25a1 1 0 0 0-1 1V6A6.624 6.624 0 0 0 1.25 11.625a1 1 0 0 0 1 1H6a6.624 6.624 0 0 0 5.625 10.125 1 1 0 0 0 1-1V18a6.63 6.63 0 0 0 8.875-1.751 6.63 6.63 0 0 0 1.25-3.874 1 1 0 0 0-1-1H18a6.627 6.627 0 0 0-1.751-8.874 6.63 6.63 0 0 0-3.874-1.251m3.365 12.125h4.901a4.626 4.626 0 0 1-8.016 2.023v-2.023zm-.342-2a4.625 4.625 0 0 0-2.023-8.016v8.016zm-4.773 4.365v-3.115H8.602a4.625 4.625 0 0 0 2.023 8.016V15.74m.75-5.115V8.602a4.625 4.625 0 0 0-8.016 2.023z",
    clipRule: "evenodd"
  })));
};
export default SvgIconGooglePhotosLogo;